import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Clock } from 'react-feather';

/**
 * ActionCard component for displaying a single action item in the Indoor Casepaper dashboard.
 */
const ActionCard = ({ data, isPatientPlanId }) => {
    const Icon = data.icon;

    return (
        <div className="action-card">
            <div className="card-header-section">
                <div className="icon-wrapper" style={{ background: data.bgColor, color: data.color }}>
                    <Icon size={28} />
                </div>
                <div className="d-flex flex-column align-items-end gap-1">
                    <span className="category-badge">{data.category}</span>
                    {data.isFilled && <span className="status-badge-filled">Completed</span>}
                </div>
            </div>

            <div className="card-content">
                <h3 className="card-title">{data.title}</h3>
                <p className="card-description">{data.description}</p>
            </div>

            {data.hasAction && isPatientPlanId && (
                <div className="card-footer">
                    <Link to={data.link} className={`action-button ${data.isFilled ? 'filled' : ''}`}>
                        <span>{data.buttonText}</span>
                        <ChevronRight size={18} />
                    </Link>
                </div>
            )}

            {!isPatientPlanId && (
                <div className="card-footer disabled">
                    <div className="coming-soon-badge">
                        <Clock size={14} />
                        <span>Patient Plan is not available</span>
                    </div>
                </div>
            )}

            {isPatientPlanId && !data.hasAction && (
                <div className="card-footer disabled">
                    <div className="coming-soon-badge">
                        <Clock size={14} />
                        <span>Coming Soon</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default React.memo(ActionCard);
